import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class PersonalInfoService {

  private _token = '';
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    this._token = localStorage.getItem('token');
    //console.log('person info service');
  }

  postPersonalInfo$(info: any): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')});
    return this.http.post(this.config.apiEndpoint + 'personalinfo/add-personal-information', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getPersonalInfo(info: any): Observable<any> {

    /* const headers = new Headers({ 'Content-Type': 'application/json'});
    return this.http.post(this.config.apiEndpoint +'personalinfo/get-personal-information', info, {
      headers: headers
    })
    .catch(this.handleErrorObservable); */
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint +'personalinfo/get-personal-information', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch(this.handleErrorObservable); // ...errors if any


  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/personal-info.service.ts